
import { ProjectModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { projectsStore } from '@/libs/projects/+state/store';

@Component({})
export default class ProjectSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) marginTop6!: boolean;
    @Prop({ default: false }) truncateSelection!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): ProjectModel[] {
        return [...(projectsStore.useGetter(CrudGetter.Data) as ProjectModel[])].sort((a: ProjectModel, b: ProjectModel) => {
            if (a.name! < b.name!) {
                return -1;
            }
            if (a.name! > b.name!) {
                return 1;
            }
            return 0;
        });
    }

    onChange(e: any) {
        this.$emit('input', e);
        this.$nextTick(() => this.$emit('change', e));
    }
}
